import { persist } from "zustand/middleware";
import { createWithEqualityFn } from "zustand/traditional";

export enum ColorTheme {
  Light = "light",
  Dark = "dark",
}

interface AppSettingsState {
  theme: ColorTheme;
  inputLanguage: string;
  toggleTheme: () => void;
  setInputLanguage: (language: string) => void;
}

export const useAppSettingsStore = createWithEqualityFn<AppSettingsState>()(
  persist(
    (set, get) => ({
      theme: ColorTheme.Light,
      inputLanguage: "eng",
      toggleTheme: (): void => {
        const currentTheme = get().theme;
        const newTheme =
          currentTheme === ColorTheme.Dark ? ColorTheme.Light : ColorTheme.Dark;
        document.documentElement.classList.toggle(
          ColorTheme.Dark.toString(),
          newTheme === ColorTheme.Dark
        );
        set({ theme: newTheme });
      },
      setInputLanguage: (language: string): void => {
        set({ inputLanguage: language });
      },
    }),
    {
      name: "app-settings",
      onRehydrateStorage:
        () =>
        (state): void => {
          if (state) {
            document.documentElement.classList.toggle(
              ColorTheme.Dark.toString(),
              state.theme === ColorTheme.Dark
            );
          }
        },
    }
  )
);
